import React, {useEffect, useState} from "react";
import styles from "./PaymentDetails.module.css";
import Box from "@mui/material/Box";
import {useSectionsRefs} from "../../../components/mainWrapper/MainWrapper";
import {Elements} from "@stripe/react-stripe-js";
import {loadStripe, StripeElementsOptions} from "@stripe/stripe-js";
import useDataFetch from "../../../hooks/useDataFetch";
import PaymentDetailsCheckout from "./PaymentDetailsCheckout";

export interface SetupIntentResponse {
    clientSecret: string | null;
    publishableKey: string | null;
}

const stripePromise = loadStripe(process.env.STRIPE_PUBLISHABLE_KEY || 'pk_live_51REejiGhFRYYnLQAt14IJt4WLhy8XSROBVd4j07gbw6BWUy7CjFJuJzdvuZCDrgTrDjbCHKUfjpHjOUcLgHQbgtL00PiGesccp')


const PaymentDetails = () => {

    const [options, setOptions] = useState<StripeElementsOptions | null>(null);

    const {data} = useDataFetch<SetupIntentResponse>(`/stripe/create-setup-intent`, true, true);

    const {
        setNavItems,
    } = useSectionsRefs();

    useEffect(() => {
        setNavItems([]);
    }, []);

    useEffect(() => {
        if (data) {
            setOptions({
                clientSecret: data.clientSecret,
                appearance: {
                    theme: 'stripe',
                    variables: {
                        colorPrimary: '#6772E5',
                        colorBackground: '#ffffff',
                        colorText: '#32325d',
                        colorDanger: '#df1b41',
                        fontFamily: 'Inter, sans-serif',
                    },
                },
            });
        }
    }, [data]);

    return (
        <div className={styles.container}>
            <Box sx={{
                width: "100%",
                backgroundColor: 'secondary.main',
                alignContent: 'center',
                height: "100%",
            }}>

                <Box
                    sx={{
                        backgroundColor: "secondary.main",
                        display: "flex",
                        justifyContent: "center",
                    }}
                >
                    <div className={styles.content}>
                        <div className={styles.realContent}>
                            {options && stripePromise && (
                                <Elements stripe={stripePromise} options={options}>
                                    <PaymentDetailsCheckout/>
                                </Elements>
                            )}
                        </div>
                    </div>

                </Box>

            </Box>
        </div>
    );
}

export default PaymentDetails
